var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeuliezLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 222.5 55.4",
    style: {
      enableBackground: "new 0 0 222.5 55.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54,19.5h15c0.8,0,1.5-0.7,1.5-1.5v-2.4c0-0.8-0.7-1.5-1.5-1.5H48.5c-0.8,0-1.5,0.7-1.5,1.5v24.1 c0,0.8,0.7,1.5,1.5,1.5H69c0.8,0,1.5-0.7,1.5-1.5v-2.4c0-0.8-0.7-1.5-1.5-1.5H54v-5.5h11.4c0.8,0,1.5-0.7,1.5-1.5v-2.2 c0-0.8-0.7-1.5-1.5-1.5H54V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.2,19.5h15c0.8,0,1.5-0.7,1.5-1.5v-2.4c0-0.8-0.7-1.5-1.5-1.5h-20.5c-0.8,0-1.5,0.7-1.5,1.5v24.1 c0,0.8,0.7,1.5,1.5,1.5h20.5c0.8,0,1.5-0.7,1.5-1.5v-2.4c0-0.8-0.7-1.5-1.5-1.5h-15v-5.5h11.4c0.8,0,1.5-0.7,1.5-1.5v-2.2 c0-0.8-0.7-1.5-1.5-1.5h-11.4V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.9,14h-4c-0.8,0-1.5,0.7-1.5,1.5V25H20.1v-9.4c0-0.8-0.7-1.5-1.5-1.5h-4c-0.8,0-1.5,0.7-1.5,1.5v24.1 c0,0.8,0.7,1.5,1.5,1.5h4c0.8,0,1.5-0.7,1.5-1.5v-9.4h12.3v9.4c0,0.8,0.7,1.5,1.5,1.5h4c0.8,0,1.5-0.7,1.5-1.5V15.5 C39.4,14.7,38.8,14,37.9,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.2,35.7h-15V15.5c0-0.8-0.7-1.5-1.5-1.5h-4c-0.8,0-1.5,0.7-1.5,1.5v24.1c0,0.8,0.7,1.5,1.5,1.5h20.5 c0.8,0,1.5-0.7,1.5-1.5v-2.5C134.7,36.4,134,35.7,133.2,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.6,15.5v24.1c0,0.8,0.7,1.5,1.5,1.5h4c0.8,0,1.5-0.7,1.5-1.5V15.5c0-0.8-0.7-1.5-1.5-1.5h-4 C140.2,14,139.6,14.7,139.6,15.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.4,14c-0.8,0-1.5,0.7-1.5,1.5v15.7c0,2.1-0.4,3.4-1.2,4C95,35.7,93.2,36,90.4,36c-2.7,0-4.4-0.3-5.2-0.8 c-0.8-0.5-1.2-1.6-1.2-3.8V15.5c0-0.8-0.7-1.5-1.5-1.5h-4c-0.8,0-1.5,0.7-1.5,1.5v16.8c0,3.7,0.8,6.1,2.5,7.3s5.2,1.7,10.6,1.7 c0.2,0,0.3,0,0.5,0s0.4,0,0.6,0c5.1,0,8.5-0.6,10.1-1.8c1.7-1.2,2.5-3.7,2.5-7.5V15.5c0-0.8-0.7-1.5-1.5-1.5H98.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.8,35.7h-15.3l16.2-16.9c0.3-0.3,0.4-0.6,0.4-1v-2.2c0-0.8-0.7-1.5-1.5-1.5h-22.5c-0.8,0-1.5,0.7-1.5,1.5 v2.5c0,0.8,0.7,1.5,1.5,1.5h15.2l-16.4,16.8c-0.3,0.3-0.4,0.6-0.4,1v2.3c0,0.8,0.7,1.5,1.5,1.5h22.8c0.8,0,1.5-0.7,1.5-1.5v-2.5 C209.3,36.4,208.6,35.7,207.8,35.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeuliezLogoWhite);
export default __webpack_public_path__ + "static/media/HEULIEZ_Logo_White.fea13ab40df752d36c04195da2606676.svg";
export { ForwardRef as ReactComponent };